<wtf-dialogcontent [size]="'md'" class="upload-csv-dialog" [dialogTitle]="dialogTitle" (closeModal)="close()"
    [action]="action">
    <!-- Content -->
    <div *ngIf="processing === false && finished === false">
        <form name="smsCsvForm" [formGroup]="smsCsvForm" class="upload-csv-form w-100-p" fxLayout="column" fxFlex>
            <mat-label>{{ "Delimitador" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-select name="delimiter" formControlName="delimiter" placeholder="">
                    <mat-option *ngFor="let delimitador of delimitadores" [value]="delimitador.value">{{
                        delimitador.delimiterValue }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-label>{{ "Nombre de la Campaña" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder=""
                    [readonly]="action === recordAction.View" required />
            </mat-form-field>
            <mat-label>{{ "Codigo Corto" | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-select name="shortcode" formControlName="shortcode" placeholder="">
                    <mat-option *ngFor="let shortCode of shortCodes" [value]="shortCode.id">{{
                        shortCode.operator.name + " - " + shortCode.value
                        }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-label>{{ "Periodo de Validez" | translate }}*</mat-label>
            <mat-form-field appearance="outline" class="w-100-p">
                <input required matInput #input type="number" name="message" [readonly]="action === recordAction.View"
                    formControlName="validityPeriod" placeholder="" />
                <mat-hint align="start"> {{ "Horas" | translate }}</mat-hint>
            </mat-form-field>
            <mat-checkbox name="instantaneo" (change)="onChangeHideMessage($event)">{{
                "Ocultar" | translate
                }}</mat-checkbox>
            <mat-checkbox name="instantaneo" (change)="hasUrl($event)">{{
                "Agregar URL" | translate
                }}</mat-checkbox>

            <div *ngIf="hasURL">
                <mat-label>{{ "URL" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <input matInput #input maxlength="150" name="message" [readonly]="action === recordAction.View"
                        formControlName="longUrl" placeholder="" />
                </mat-form-field>
            </div>

            <div fxLayoutAlign="center center" *ngIf="action !== recordAction.View"
                style="padding-top: 20px !important; margin-bottom: 20px">
                <div class="upload-container">
                    <div class="upload-button">
                        <label for="file" class="custom-file-upload">
                            {{ "Seleccionar archivo" | translate }}
                        </label>
                    </div>

                    <mat-label class="file-name">{{
                        "No se eligió el archivo" | translate
                        }}</mat-label>
                </div>
                <input #myInput type="file" id="file" (change)="handleFileInput($event.target.files)" />
                <input type="hidden" name="fileHidden" formControlName="fileInput" />
            </div>

            <!--  <mat-form-field class="w-100-p">
                    <input matInput name="serviceType" formControlName="serviceType" mat-maxlength="50" placeholder="Identificador de Campaña" [readonly]="action===recordAction.View" >
                </mat-form-field> -->
            <button *ngIf="processing === false && finished === false" mat-raised-button (click)="performAction()"
                class="save-button" [disabled]="smsCsvForm.invalid" aria-label="Enviar">
                <span class="material-icons-outlined mr-24"> send </span>
                {{ "Enviar" | translate }}
            </button>

            <button *ngIf="processing === false && finished === true" mat-raised-button (click)="close()"
                class="save-button" aria-label="Cerrar">
                <span class="material-icons-outlined mr-24"> close </span>
                {{ "Cerrar" | translate }}
            </button>
        </form>
    </div>

    <div fxLayout="column" fxLayoutAlign="center center" class="wait-indicator"
        *ngIf="processing === true && finished === false">
        <mat-spinner></mat-spinner>

        <mat-label>{{ "Procesando. Espere Por Favor" | translate }}</mat-label>
    </div>

    <div *ngIf="processing === false && finished === true">
        <ngx-charts-advanced-pie-chart [view]="view" [scheme]="widget6.scheme" [results]="results"
            [label]="widget6.label">
        </ngx-charts-advanced-pie-chart>
    </div>
    <!-- Content -->

    <!-- Buttons -->

    <!-- Buttons -->
</wtf-dialogcontent>